// AUTO-GENERATED barrel: aggregates all cuisine recipe modules

import { indonesianRecipes } from './indonesian';
import { japaneseRecipes } from './japanese';
import { koreanRecipes } from './korean';
import { italianRecipes } from './italian';
import { mexicanRecipes } from './mexican';
import { chineseRecipes } from './chinese';
import { thaiRecipes } from './thai';
import { indianRecipes } from './indian';
import { westernRecipes } from './western';
import { fusionRecipes } from './fusion';

export const recipeDatabase = [
  indonesianRecipes,
  japaneseRecipes,
  koreanRecipes,
  italianRecipes,
  mexicanRecipes,
  chineseRecipes,
  thaiRecipes,
  indianRecipes,
  westernRecipes,
  fusionRecipes
].flat();


export const cuisines = [
  'All',
  'Indonesian',
  'Japanese',
  'Korean',
  'Western',
  'Italian',
  'Mexican',
  'Chinese',
  'Thai',
  'Indian',
  '✨ Fusion'
];
